import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

Avatar.theme = Avatar.theme || {};

Avatar.theme.StoreAvailability = function StoreAvailabilityFn() {
  var selectors = {
    storeAvailabilityModalOpen: '[data-store-availability-modal-open]',
    storeAvailabilityModalProductTitle: '[data-store-availability-modal-product-title]',
    storeAvailabilityModalVariantTitle: '[data-store-availability-modal-variant-title]'
  };
  var classes = {
    hidden: 'tw-hidden'
  };

  function StoreAvailability(container) {
    this.container = container;
    this.productTitle = this.container.dataset.productTitle;
    this.hasOnlyDefaultVariant = this.container.dataset.hasOnlyDefaultVariant === 'true';
  }

  StoreAvailability.prototype = _objectSpread(_objectSpread({}, StoreAvailability.prototype), {}, {
    updateContent: function updateContent(variantId) {
      var variantSectionUrl = "".concat(this.container.dataset.baseUrl, "/variants/").concat(variantId, "/?section_id=store-availability");
      var self = this;
      var storeAvailabilityModalOpen = self.container.querySelector(selectors.storeAvailabilityModalOpen);
      this.container.style.opacity = 0.5;

      if (storeAvailabilityModalOpen) {
        storeAvailabilityModalOpen.disabled = true;
        storeAvailabilityModalOpen.setAttribute('aria-busy', true);
      }

      fetch(variantSectionUrl).then(function (response) {
        return response.text();
      }).then(function (storeAvailabilityHTML) {
        if (storeAvailabilityHTML.trim() === '') {
          return;
        }

        self.container.innerHTML = storeAvailabilityHTML;
        self.container.innerHTML = self.container.firstElementChild.innerHTML;
        self.container.style.opacity = 1; // Need to query this again because we updated the DOM

        storeAvailabilityModalOpen = self.container.querySelector(selectors.storeAvailabilityModalOpen);

        if (!storeAvailabilityModalOpen) {
          return;
        }

        storeAvailabilityModalOpen.addEventListener('click', self._onClickModalOpen.bind(self));
        self.modal = self._initModal();

        self._updateProductTitle();

        if (self.hasOnlyDefaultVariant) {
          self._hideVariantTitle();
        }
      });
    },
    clearContent: function clearContent() {
      this.container.innerHTML = '';
    },
    _onClickModalOpen: function _onClickModalOpen() {
      this.container.dispatchEvent(new CustomEvent('storeAvailabilityModalOpened', {
        bubbles: true,
        cancelable: true
      }));
    },
    _initModal: function _initModal() {
      return new Avatar.theme.Modals('StoreAvailabilityModal', 'store-availability-modal', {
        closeModalOnClick: true,
        close: '.js-modal-close-store-availability-modal',
        drawer: true,
        container: this.container
      });
    },
    _updateProductTitle: function _updateProductTitle() {
      var storeAvailabilityModalProductTitle = this.container.querySelector(selectors.storeAvailabilityModalProductTitle);
      storeAvailabilityModalProductTitle.textContent = this.productTitle;
    },
    _hideVariantTitle: function _hideVariantTitle() {
      var storeAvailabilityModalVariantTitle = this.container.querySelector(selectors.storeAvailabilityModalVariantTitle);
      storeAvailabilityModalVariantTitle.classList.add(classes.hidden);
    }
  });
  return StoreAvailability;
}();